import React, { createContext, useContext, useState, useCallback } from "react";
import { Toast, ToastContainer } from "react-bootstrap";

const NotificationContext = createContext();

let idCounter = 0;

export const NotificationProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const notify = useCallback((message, variant = "info") => {
    const id = ++idCounter;
    setToasts((prev) => [...prev, { id, message, variant }]);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return (
    <NotificationContext.Provider value={{ notify }}>
      {children}
      <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
        {toasts.map((t) => (
          <Toast
            key={t.id}
            bg={t.variant}
            onClose={() => removeToast(t.id)}
            delay={4000}
            autohide
          >
            <Toast.Header>
              <strong className="me-auto">
                {t.variant === "success" && "Success"}
                {t.variant === "danger" && "Error"}
                {t.variant === "warning" && "Warning"}
                {t.variant === "info" && "Info"}
              </strong>
            </Toast.Header>
            <Toast.Body className={t.variant === "dark" || t.variant === "danger" ? "text-white" : ""}>
              {t.message}
            </Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
